import React from 'react';

/**
 * A keyboard-accessible, section-level explanation using the Fleet Health
 * score help treatment. The tooltip remains visible while its trigger has
 * focus, matching the existing score-card help behavior.
 */
function SectionTooltip({ id, label, children, className = '' }) {
    return (
        <div className={`snapshot-score-tooltip section-tooltip ${className}`.trim()}>
            <button
                type="button"
                className="snapshot-score-tooltip-trigger"
                aria-label={label}
                aria-describedby={id}
            >
                i
            </button>
            <div id={id} className="snapshot-score-tooltip-content" role="tooltip">
                {children}
            </div>
        </div>
    );
}

export default SectionTooltip;
